export default __webpack_public_path__ + "media/zurb/img/lab/playground/orbit-arrow-left-3aa77d260f311319ae44521a491bae04.svg";